import * as React from "react";
import Component from "../../AbstractComponent";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { downloadGlobalCharges } from "../../../Saga/Actions/globalChargesActions";

export class DownloadEntityPrompt extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedYear: new Date().getFullYear() - 1,
    };

    this.cancel = this.cancel.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.download = this.download.bind(this);
  }

  cancel() {
    if (typeof this.props.onCancel !== "undefined") {
      this.props.onCancel.call(this);
    }
  }

  handleYearChange(event) {
    this.setState({ selectedYear: event.target.value });
  }

  download() {
    const { ownerId } = this.props; 
    const { selectedYear } = this.state;
    const { lng } = this.props;
    const { userlng } = this.props;
    this.props.dispatch(downloadGlobalCharges(ownerId, selectedYear, lng, userlng, {
      onSuccess: () => {
        this.props.onCancel.call(this);
      },
      onError: () => {}
    }));
    this.props.onCancel.call(this);
  }

  render() {
    const { selectedYear } = this.state;
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    return (
      <Dialog
        className="dialog dialog-window has-button-padding"
        open={this.props.isOpen}
        onClose={this.cancel}
        disableBackdropClick={true}
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              minHeight: "calc(24px + 2em)"
            }}>
            <h4>{this.trans("select-year-charts")}</h4>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="dialog-content-wrapper">
            <FormControl fullWidth>
              <InputLabel>{this.trans("select-year-charts-label")}</InputLabel>
              <Select
                value={selectedYear}
                onChange={this.handleYearChange}
              >
                <MenuItem value={previousYear}>{previousYear}</MenuItem>
                <MenuItem value={currentYear}>{currentYear}</MenuItem>
              </Select>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="dialog-buttons-wrapper">
            <Button
              color="primary"
              onClick={this.cancel}
            >
              {this.trans("button-cancel")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={this.download}
            >
              {this.trans("button-download")}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    );
  }
}